import { render, staticRenderFns } from "./pautaTrimestral_2020.vue?vue&type=template&id=338cdf44&"
import script from "./pautaTrimestral_2020.vue?vue&type=script&lang=js&"
export * from "./pautaTrimestral_2020.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports